import React, { Component } from 'react';

import './style.scss';
import DetailLabel from 'components/DetailLabel';
import { ChatWebsiteShape } from 'entities';

class ChatWebsite extends Component {

  render() {
    const chatWebsite = this.props.chatWebsite;

    return (
      <div className="ChatResource ChatWebsite">
        <div className="preview">
          {(() => {
            if(chatWebsite.image) {
              return (
                <div className="image">
                  <img src={chatWebsite.image} />
                </div>
              );
            }
          })()}

          <div className="content">
            {(() => {
              if(chatWebsite) {
                return <h5>{chatWebsite.title}</h5>;
              }
            })()}

            {(() => {
              if(chatWebsite.description) {
                <p>{chatWebsite.description}</p>;
              }
            })()}

            <p className="url">{chatWebsite.url}</p>
          </div>

          <a className="Link" href={chatWebsite.url} target="_blank">&nbsp;</a>
        </div>

        <DetailLabel>{__('members.chat.items.websiteHelp')}</DetailLabel>
      </div>
    );
  }
}

ChatWebsite.propTypes = {
  chatWebsite: ChatWebsiteShape
};

export default ChatWebsite;



/** WEBPACK FOOTER **
 ** ./src/members/Main/ChatWindow/ChatItems/ChatWebsite/index.js
 **/